module.exports = __webpack_public_path__ + "fonts/nucleo-icons.ff208b8d.woff2";